import { on } from "svelte/events";

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const unmaskElement = (ev: Event): void => {
  if (!ev.target) return;
  const element = ev.target as HTMLElement;
  const maskedRef = element.dataset.maskedRef;
  if (!maskedRef) return;

  const decodedHref = atob(maskedRef);

  /*                                                                            */
  if (element instanceof HTMLAnchorElement) {
    element.href = decodedHref;
    delete element.dataset.maskedRef;
    return;
  }

  /*                                                                      */
  const anchorElement = document.createElement("a");

  /*                                                                      */
  Array.from(element.attributes)
    .filter((attr) => attr.name !== "data-masked-ref")
    .forEach(({ name, value }) => anchorElement.setAttribute(name, value));

  /*                                                                               */
  /*                                           */
  anchorElement.__ocAutoAriaLabel = element.__ocAutoAriaLabel;

  /*                                                              */
  anchorElement.href = decodedHref;

  /*                                                  */
  anchorElement.append(...element.childNodes);

  /*                                                                      */
  element.parentNode?.replaceChild(anchorElement, element);

  /*                                                                 */
  if (ev instanceof FocusEvent && ev.target === element) {
    anchorElement.focus();
  }
};

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
["focusin", "mouseover", "touchstart"].forEach((eventName) =>
  on(document.body, eventName, unmaskElement, {
    passive: true,
  }),
);
